import {useState, useEffect} from 'react';
import {useDebounce} from './useDebounce';
import {CompanySuggestion} from '../api-client/models/company';
import {createCompanyManager} from '../di';

const MIN_QUERY_LENGTH = 2;
const DEFAULT_DEBOUNCE_MS = 300;

export function useCompanySuggestions(query: string, debounceMs = DEFAULT_DEBOUNCE_MS) {
  const debouncedQuery = useDebounce(query, debounceMs);
  const [suggestions, setSuggestions] = useState<CompanySuggestion[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const trimmed = debouncedQuery?.trim() ?? '';
    if (trimmed.length < MIN_QUERY_LENGTH) {
      setSuggestions([]);
      return;
    }

    let cancelled = false;
    setLoading(true);

    (async () => {
      try {
        const manager = await createCompanyManager();
        const result = await manager.get(trimmed);
        if (!cancelled) setSuggestions(result);
      } catch {
        if (!cancelled) setSuggestions([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [debouncedQuery]);

  return {suggestions, loading};
}
